// extracted by mini-css-extract-plugin
export default {"section":"DrugInfoSection_section__LT3jO","sectionTitle":"DrugInfoSection_sectionTitle__8ud3r","sectionContent":"DrugInfoSection_sectionContent__d54ak"};